import GlobalNavigationMainSection from './GlobalNavigationMainSection'
export default GlobalNavigationMainSection